import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScanCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconScanCode"><Path d="M4.5 19.5H9V21H3V15H4.5V19.5Z" fill="currentColor"/><Path d="M21 21H15V19.5H19.5V15H21V21Z" fill="currentColor"/><Path d="M8 15H7V9H8V15Z" fill="currentColor"/><Path d="M11 15H9V9H11V15Z" fill="currentColor"/><Path d="M13 15H12V9H13V15Z" fill="currentColor"/><Path d="M15 15H14V9H15V15Z" fill="currentColor"/><Path d="M17 15H16V9H17V15Z" fill="currentColor"/><Path d="M9 4.5H4.5V9H3V3H9V4.5Z" fill="currentColor"/><Path d="M21 9H19.5V4.5H15V3H21V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconScanCode;
